import { FixDataPage } from '../../components/FixDataPage';
import defaultSheets from '../../config/default_sheets';

const FixCustomerGroupPage = () => {
  return (
    <FixDataPage
      title="Fix Customer Group"
      columns={[
        { name: 'customer', type: 'text' },
        { name: 'customer_group', type: 'text' },
        { name: 'customer_category', type: 'text' },
      ]}
      dataType={'customer_group'}
      spreadsheetId={defaultSheets.CustomerGroup.defaultSheetUrl}
      spreadsheetRange={defaultSheets.CustomerGroup.defaultRange}
      pageId={'fix_customer_group'}
    />
  );
};

export default FixCustomerGroupPage;